module.exports = __webpack_public_path__ + "static/media/有沒有參加過政府防災宣導、教育、演習.1a588b5d.png";